"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.135
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStatusToJSON = exports.AccountStatusFromJSONTyped = exports.AccountStatusFromJSON = exports.AccountStatus = void 0;
/**
 * The status of the account
 * @export
 * @enum {string}
 */
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["PENDING"] = "PENDING";
    AccountStatus["PENDINGMATCH"] = "PENDING_MATCH";
    AccountStatus["PENDINGDUPLICATE"] = "PENDING_DUPLICATE";
    AccountStatus["PENDINGMATCHANDDUPLICATE"] = "PENDING_MATCH_AND_DUPLICATE";
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["TERMINATIONREQUESTED"] = "TERMINATION_REQUESTED";
    AccountStatus["TERMINATED"] = "TERMINATED";
    AccountStatus["REJECTED"] = "REJECTED";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
function AccountStatusFromJSON(json) {
    return AccountStatusFromJSONTyped(json, false);
}
exports.AccountStatusFromJSON = AccountStatusFromJSON;
function AccountStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AccountStatusFromJSONTyped = AccountStatusFromJSONTyped;
function AccountStatusToJSON(value) {
    return value;
}
exports.AccountStatusToJSON = AccountStatusToJSON;
